import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Switch } from '@cp/ds/src/components/switch';
import { styled } from '@cp/ds/src/theme';
import { AvailableOnlyFieldProps, FormAvailableOnlyFieldName } from './model';
import { useAvailableOnlyField } from './useAvailableOnlyField';

const Root = styled(Box, { name: 'AvailableOnlyRoot' })(({ theme }) => ({
  paddingRight: '12px',
  paddingLeft: '16px',
  paddingTop: '10px',
  paddingBottom: '10px',
  border: `1px solid ${theme.palette['gray light']}`,
  borderRadius: theme.borderRadius.normal,
  backgroundColor: theme.palette.white,
  display: 'flex',
  alignItems: 'center',
}));

type AvailableOnlyFieldOwnProps = {
  isMobile?: boolean;
};

export const AvailableOnlyField: React.FC<AvailableOnlyFieldProps & AvailableOnlyFieldOwnProps> = ({ form, isMobile = false }) => {
  const { onChange, value } = useAvailableOnlyField({ form });

  const content = (
    <Switch
      inputName={FormAvailableOnlyFieldName.AvailableOnly}
      label="Показать только доступных"
      labelPosition="left"
      labelTypography="caption bold"
      onChange={onChange}
      sx={{ display: 'flex', justifyContent: 'space-between' }}
      value={value}
    />
  );

  if (!isMobile) {
    return content;
  }

  return <Root>{content}</Root>;
};
